import { Injectable, signal } from '@angular/core';
import { SignalStore } from './signal-store';

export interface Partner {
  code: string;
  name: string;
  logoFile: string;
  logoWidth: number;
  logoHeight: number;
  address: string;
  phone: string;
  email: string;
  url: string;
  adImage?: string;
  adUrl?: string;
}

@Injectable({
  providedIn: 'root'
})
export class PartnerService extends SignalStore<Partner>  {

  private partners: Partner[] = [
    {
      code: 'vbc',
      name: 'VBC',
      logoFile: 'logo-vbc.svg?v=2',
      logoWidth: 300,
      logoHeight: 81,
      address: '721 Millbrook Ln, Haverford, PA 19041',
      phone: '6105261869',
      email: 'support@velliganblaxall.com',
      url: 'https://www.velliganblaxall.com/',
      adImage: 'vbc-cecl.jpg',
      adUrl: 'https://www.velliganblaxall.com/services/cecl/'
    }];

  constructor() {
    super();
    //this.setPartner('vbc');
  }

  public setPartner(code?: string): void {
    this.state.set(this.partners.find(p => p.code == code) ?? {} as Partner);
  }
}
